import { clear, get, set } from "./local-storage";

const USER_TOKEN_LOCAL_STORAGE_KEY = "user_token";
export const setOnLocalStorage = (clinic) => set(USER_TOKEN_LOCAL_STORAGE_KEY, clinic);
export const getFromLocalStorage = () => get(USER_TOKEN_LOCAL_STORAGE_KEY);
export const clearOnLocalStorage = () => clear(USER_TOKEN_LOCAL_STORAGE_KEY);